import { initDebug } from './debug';
import '../../devtools';

initDebug();

export { resetPropWarnings } from './check-props';
